import BaseViewController from "./base-view-controller";

const formatPhone = (phone, extension) => {
  const result = `(${phone.substring(0, 3)}) ${phone.substring(
    3,
    6
  )}-${phone.substring(6)}`;
  return extension ? `${result} +${extension}` : result;
};

class DoctorDetailViewController extends BaseViewController {
  preprocessScreenData() {
    const { values } = this.appData;
    const phoneButton = this.screen.fields.find(
      field => field.name === "doctor_phone_button"
    );
    const faxButton = this.screen.fields.find(
      field => field.name === "doctor_fax_button"
    );
    let formattedPhone;
    if (values["phone_faxes.0.phone_number"]) {
      formattedPhone = formatPhone(
        values["phone_faxes.0.phone_number"],
        values["phone_faxes.0.extension"]
      );
      phoneButton.title = formattedPhone;
      phoneButton.action.value = formattedPhone;
    } else {
      this.screen.fields = [
        ...this.screen.fields.filter(
          field => field.name !== "doctor_phone_button"
        )
      ];
    }
    if (values["phone_faxes.1.phone_number"]) {
      formattedPhone = formatPhone(
        values["phone_faxes.1.phone_number"],
        values["phone_faxes.1.extension"]
      );
      faxButton.title = formattedPhone;
      faxButton.action.value = formattedPhone;
    } else {
      this.screen.fields = [
        ...this.screen.fields.filter(
          field => field.name !== "doctor_fax_button"
        )
      ];
    }
  }
}

export default DoctorDetailViewController;
